import React from 'react';

import { Box, useTheme } from '@mui/material';

export const cardStyles = (theme: any) => ({
  wrapper: {
    position: 'relative',
    display: 'inline-block',
    padding: '10px 20px 20px 20px',
    border: `1px solid ${theme.custom?.pureBlack}`,
    borderRadius: '8px',
    width: '100%',
    borderColor: theme.border?.labeledCard || '',
    boxSizing: 'border-box',
  },
  label: {
    position: 'absolute',
    top: '-12px',
    left: '10%',
    backgroundColor:
      theme.background?.white ?? theme.colors?.alpha?.white?.[100],
    padding: '0 5px',
    fontWeight: '700',
    fontSize: '11px',
    letterSpacing: '0.88px',
    color: theme.palette.text.secondary || '',
  },
  content: {},
});

type LabeledCardProps = {
  label: string;
  children: React.ReactNode;
  sx?: {
    wrapper?: React.CSSProperties;
    label?: React.CSSProperties;
    content?: React.CSSProperties;
  };
};

export const LabeledCard: React.FC<LabeledCardProps> = ({
  label,
  children,
  sx = {},
}) => {
  const theme = useTheme();

  const wrapperStyle = {
    ...cardStyles(theme).wrapper,
    ...sx.wrapper,
  };

  const labelStyle = {
    ...cardStyles(theme).label,
    ...sx.label,
  };

  const contentStyle = {
    ...cardStyles(theme).content,
    ...sx.content,
  };

  return (
    <Box sx={wrapperStyle}>
      <Box sx={labelStyle}>{label}</Box>
      <Box sx={contentStyle}>{children}</Box>
    </Box>
  );
};

export default LabeledCard;
